<template>
    <div>
        <div class="container">
          <div class="row text-light pb-3 pt-2 mt-1">
            <div class="col-12">
              <form @submit.prevent="searchExperiments()" class="search-form search-form-theme2 w-100">
                <img src="@/assets/images/skeleton/search.png" class="fas fa-search search-icon" alt="search" @click="searchExperiments()">
                <input
                  type="text"
                  v-model="searchQuery"
                  placeholder="Search in Experiments"
                  name="Search"
                  class="search-input"
                />
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="container">
                <div class="row">
                  <div class="col-md-4" v-for="(item, index) in filteredItems" :key="item.id || index">
                    <div class="card bg-transparent" @click="navigateEXP(item.id)" v-if="item">
                      <div class="image-wrapper">
                        <div class="img-exp">
                          <img :src="`${item.image}`" alt="image" style="height: 246px; width:246px ;border-radius: 5px;">
                          <img src="@/assets/images/skeleton/play.png" class="play-button" alt="play-button" @click.stop="openExperiment(item.targetPackage)">
                        </div>
                      </div>
                      <div class="py-50 pl-50">
                        <h3 class="mb-0" v-if="item.name">{{item.name}}</h3>
                        <p class="opacity-75" v-if="item.category">{{item.category.name}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
    </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import DragTable from "@/views/components/tables/DragTable.vue";

import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  VBTooltip,
  BLink,
  BSpinner,
  BPagination
} from "bootstrap-vue";
export default {
  name: "topics",
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BCardText,
    BLink,
    BSpinner,
    BPagination,
    ToastificationContent,
    DragTable,
    vSelect
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      items: "experiments/items",
      load: "experiments/load",
      courses: "experiments/lookups",
      modules: "experiments/lookups"
    }),
    filteredItems() {
      
      if (!this.searchQuery) return this.items;
      const query = this.searchQuery.toLowerCase();
      return this.items.filter(item =>
        item.name?.toLowerCase().includes(query) ||
        item.category?.name?.toLowerCase().includes(query)
      );
    }
  },
  data() {
    return {
      searchQuery: ''
    };
  },
  methods: {
    init(){
      this.$store.dispatch('experiments/list').then(response=>{
      })
    },
    navigateEXP(id){
      this.$router.push({ name: 'v2_experiment_details', params: { id } });
    },
    openExperiment(id){
      console.log('ssssssssssssssssssssssssssssssssss-------------------->> ', id);
        if (id) {
            setTimeout(function() {
                window.vuplex.postMessage(id);
            }, 3);
        } else {
            console.log("No ID provided in the URL.");
        }
    },
    searchExperiments(){
      console.log('ssssssssssssssssssssssssssssssssss');
    }
  },
  mounted() {
    this.init()
  }
};
</script>
<style lang="scss" scoped>
.card, .card *{
  box-shadow: unset;
  color: #fff;
}
.image-wrapper{
  border-radius: 10px; 
  overflow: hidden;
}
.search-form {
  position: relative;
  width: 100%;
  background-color: transparent;
  border: 1px solid #ffffff75;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
}

.search-form-theme2{
  position: relative;
  width: 100%;
  border-left: none;
  border-right: none;
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
  background-color: #00000040;
  border: 1px solid #ffffff75;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgb(0 0 0 / 65%);
  border-top: unset;
}

.search-form:focus-within {
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.search-form input[type="text"],
.search-form input[type="search"] {
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.search-form input::placeholder{
  color: #ffffffa8;
}

.search-form .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #bbb;
  font-size: 16px;
  cursor: pointer;
}
.img-exp{
  max-width: fit-content;
  position: relative;
}
.play-button{
  position: absolute;
  cursor: pointer;
  bottom: 2%;
  right: 3%;
}

</style>